import React from 'react';
import * as R from 'ramda';
import styled from 'styled-components';
import { layout, border, space } from 'styled-system';
import { Box, Flex } from '@cowsquare/design';

/**
 * TODO: Move to cowsquare design
 */

export const Loading = styled.span`
  display: inline-block;
  ${layout}
  ${border}
  ${space}
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.1) 61%, rgba(0, 0, 0, 0.05));

  animation-duration: 1.5s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-name: placeholderAnimate;

  @keyframes placeholderAnimate {
    0%{ background-position: ${({ width }) => `-${width}`} 0; }
    100%{ background-position: ${({ width }) => `${width}`} 0; }
  }
`;

export const TagLoading = styled(Loading).attrs({
  width: '110px',
  height: '26px',
  borderRadius: '13px',
  mr: '4px',
  mb: '10px',
})``;

export const TagListLoading = () => R.map(x => <TagLoading key={`tagloading-${x}`} />, R.range(0, 3));

const CoverLoading = styled(Loading).attrs({
  height: '204px',
})``;

const AvatarLoading = styled(Loading).attrs({
  width: '26px',
  height: '26px',
  borderRadius: '50%',
})``;

const CardWrapper = styled(Flex)`
  ${layout}
  ${space}
  background-color: #fff;
`;

const CardContent = styled(Box).attrs({
  display: 'flex',
})`
  flex-direction: column;
  flex: 1;
`;

const coverWidthMap = {
  column: '100%',
  row: '192px',
};

const cardContentMTMap = {
  column: '12px',
  row: 0,
};

const cardContentMLMap = {
  column: '12px',
  row: '20px',
};

const cardContentPBMap = {
  column: '80px',
  row: 0,
};

export const ArticleCardLoading = ({ flexDirection = ['column', 'row'] }) => (
  <CardWrapper flexDirection={flexDirection} p="8px">
    <CoverLoading width={[].concat(flexDirection).map(x => coverWidthMap[x])} />
    <CardContent
      mt={[].concat(flexDirection).map(x => cardContentMTMap[x])}
      ml={[].concat(flexDirection).map(x => cardContentMLMap[x])}
      pb={[].concat(flexDirection).map(x => cardContentPBMap[x])}
    >
      <Flex flexDirection="Row" alignItems="center">
        <AvatarLoading mr="8px" />
        <Loading height="16px" width="150px" />
      </Flex>

      <Loading height="16px" width={'80%'} mt="40px" />
      <Loading height="8px" width={'90%'} mt="16px" />
      <Loading height="8px" width={'75%'} mt="16px" />
      <Loading height="8px" width={'80%'} mt="16px" />
    </CardContent>
  </CardWrapper>
);

export const ArticleCardListLoading = () =>
  R.map(
    x => (
      <Box key={`cardloading-${x}`} mb={5}>
        <ArticleCardLoading />
      </Box>
    ),
    R.range(0, 3)
  );

export const EventCardLoading = () => (
  <CardWrapper flexDirection="column" height="295px" p="20px">
    <Loading height="21px" width="131px" />
    <Loading height="16px" width="90%" mt="24px" />
    <Loading height="16px" width="70%" mt="16px" />
  </CardWrapper>
);

export const EventCardListLoading = () => (
  <Box mt={5} mx={-4}>
    <Flex flexWrap="wrap">
      {R.map(
        x => (
          <Box key={`cardloading-${x}`} width={[1, 1 / 3]} px={4} pb={5}>
            <EventCardLoading />
          </Box>
        ),
        R.range(0, 6)
      )}
    </Flex>
  </Box>
);

export const MedicalCardLoading = ({ hasCover }) => (
  <CardWrapper flexDirection="column" p="8px">
    {hasCover && <CoverLoading />}
    <CardContent pb="127px">
      <Loading height="16px" width="70%" mt="19px" />
      <Loading height="16px" width="90%" mt="16px" />
      <Loading height="16px" width="70%" mt="16px" />
    </CardContent>
  </CardWrapper>
);

export const MedicalCardListLoading = ({ hasCover }) => (
  <Box mt={5} mx={-4}>
    <Flex flexWrap="wrap">
      {R.map(
        x => (
          <Box key={`cardloading-${x}`} width={[1, 1 / 3]} px={4} pb={5}>
            <MedicalCardLoading hasCover={hasCover} />
          </Box>
        ),
        R.range(0, 6)
      )}
    </Flex>
  </Box>
);

const LinkCardLoading = () => (
  <CardWrapper flexDirection="column" height="118px" p="20px">
    <Loading height="16px" width="150px" />
  </CardWrapper>
);

export const LinkCardListLoading = () => (
  <Box mt={5} mx={-4}>
    <Flex flexWrap="wrap">
      {R.map(
        x => (
          <Box key={`cardloading-${x}`} width={[1, 1 / 3]} px={4} pb={5}>
            <LinkCardLoading />
          </Box>
        ),
        R.range(0, 6)
      )}
    </Flex>
  </Box>
);
